export default "__VITE_PUBLIC_ASSET__08f4fb9a__"